const isClickEvent = (event) => event.type === "click";

export { isClickEvent };
//# sourceMappingURL=event.js.map
